var angular = require('angular');

var RoutePlan = require('./routePlan');

function DistributionRoutePlan(routePlan, routes) {
  angular.extend(this, routePlan);

  this.status = RoutePlan.prototype.status.bind(this);

  this.routes = routes.filter(function(route) {
    return route.routePlanId === this.id;
  }, this);
}

DistributionRoutePlan.prototype.updateStatus = function(statusId) {
  this.statusId = statusId;
};

DistributionRoutePlan.prototype.updateCounts = function(routePlan) {
  this.deliveryCount = routePlan.deliveryCount;
  this.customerCount = routePlan.customerCount;
  this.routeCount = routePlan.routeCount;
};

DistributionRoutePlan.prototype.sortableStatus = function() {
  return {
    created: 1,
    importing: 2,
    imported: 3,
    queued: 4,
    failed: 5,
    optimizing: 6,
    routesimportqueued: 7,
    routesimporting: 8,
    generating: 9,
    routesimported: 10,
    optimized: 11,
    readyfordriverinput: 12,
    published: 13,
    deleted: 14
  }[this.status()];
};

DistributionRoutePlan.prototype.delayedRoutes = function() {
  return this.routes.filter(function(route) {
    return route.delayForHumans();
  });
};

DistributionRoutePlan.prototype.delayedUnfinishedRoutes = function() {
  return this.routes.filter(function(route) {
    return route.delayForHumans() && route.status() !== 'finished' && !! route.driver.userName;
  });
};

DistributionRoutePlan.prototype.finishedRouteCount = function() {
  return this.routes.reduce(function(count, route) {
    return route.timestampStop ? count + 1 : count;
  }, 0);
};

DistributionRoutePlan.prototype.customerRemainingCount = function() {
  return this.routes.length
    ? this.sum('customerRemainingCount')
    : this.customerCount;
};

DistributionRoutePlan.prototype.customerCancelledCount = function() {
  return this.routes.length
    ? this.sum('customerCancelledCount')
    : 0;
};

DistributionRoutePlan.prototype.customerDeliveredCount = function() {
  return this.routes.length
    ? this.sum('customerDeliveredCount')
    : 0;
};

DistributionRoutePlan.prototype.customerDeviationCount = function() {
  return this.routes.length
    ? this.sum('customerDeviationCount')
    : 0;
};

DistributionRoutePlan.prototype.deviationCount = function() {
  return this.sum('deviationCount');
};

DistributionRoutePlan.prototype.countOutdatedApps = function() {
  return this.routes.reduce(function(count, route) {
    return count + ((route.driver.shouldUpgradeApp !== null && route.driver.shouldUpgradeApp) ? 1 : 0);
  }, 0);
};

DistributionRoutePlan.prototype.sum = function(type) {
  return this.routes.reduce(function(sum, route) {
    return sum + route[type];
  }, 0);
};

DistributionRoutePlan.prototype.percentageHandled = function() {
  return (this.customerCount - this.customerRemainingCount()) / this.customerCount;
};

module.exports = DistributionRoutePlan;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/distributionRoutePlan.js
 ** module id = 171
 ** module chunks = 1
 **/